import { useCompanyPrefetch } from "@/hooks/useCompanyPrefetch";

export function CompanyContent({ children }: { children: React.ReactNode }) {
  useCompanyPrefetch();
  return <>{children}</>;
}
